export default function SharedWorker_fn() {
  return new SharedWorker(__webpack_public_path__ + "static/js/heartbeat.worker.480f16d9.worker.js");
}
